import React, { useRef, useEffect, useState, } from 'react'
import { Icon, Modal, Button, Typography, LinkText, Divider } from '../ecosystem';
import Slider from 'react-slick';

// web 
import getCareWebImg from "../../images/get-care-onboarding-carousel-web.png";
import proxySelectorWebImg from "../../images/proxy-selector-onboarding-carousel-web.png";
import nextAppointmentsWebImg from "../../images/appointment-onboarding-carousel-web.png";
import discoverNewWebImg from "../../images/discover-something-onboarding-carousel-web.png";
import navigationMenuWebImg from "../../images/health-summary-menu-onboarding-carousel-web.png";

//mWeb
import getCareMwebImg from "../../images/Get-Care-mWeb.png";
import proxyMwebImg from "../../images/Proxy-mWeb.png";
import nextApptMwebImg from "../../images/Next-Appts-mWeb.png";
import discoverNewMwebImg from "../../images/DSN-mWeb.png";
import navigationMenuMwebImg from "../../images/Refresh-menu-mWeb.png";

const ToolTip_Phase1_Started = 'tooltip_phase1_started';
const ToolTip_Phase2_Started = 'tooltip_phase2_started';
const ToolTip_Phase3_Started = 'tooltip_phase3_started';
const ToolTip_Phase4_Started = 'tooltip_phase4_started';
const ToolTip_Refresh_AllPhases_Completed = 'tooltip_refresh_allphases_completed';


const OnboardingCarouselModal = (props) => {

    const { isOpen, onDismiss, OnCloseBtn, isDesktop, isMobile, onBoardingToolTipState } = props;

    const [slides, setSlides] = useState([]);
    const [slideIndex, setSlideIndex] = useState(0);
    const sliderRef = useRef();
    const isPortraitImage = (isMobile) ? true : false;

    useEffect(() => {
        setSlides(getCurrentSlides());
    }, [isPortraitImage]);
   
    const getCurrentSlides = () => {
        let slides = [];
        let allSlides = [
            {
                id: 0,
                body: '“Get Care”  is now your home for scheduling appointments as well as finding a new doctor or location.',
                heading: 'Get Care',
                img: isPortraitImage ? getCareMwebImg : getCareWebImg,
            },
            {
                id: 1,
                body: 'Now there’s an even easier way to view and manage healthcare for every member of your family.',
                heading: 'Proxy Selector',
                img: isPortraitImage ? proxyMwebImg : proxySelectorWebImg,
            },
            {
                id: 2,
                body: "Looking for upcoming appointments and after visit  summaries? You can now find them here for all members of your family.",
                heading: "Upcoming Appointments",
                img: isPortraitImage ? nextApptMwebImg : nextAppointmentsWebImg,
            },
            {
                id: 3,
                body: 'We’ve launched a new section to help you get the most out of MyBSWHealth. See features and content to aid in your health journey.',
                heading: 'Discover Something New',
                img: isPortraitImage ? discoverNewMwebImg : discoverNewWebImg,
            },
            {
                id: 4,
                body: 'We’ve restructured our menu and included some new landing pages to group your health information and records',
                heading: 'Menu',
                img: isPortraitImage ? navigationMenuMwebImg : navigationMenuWebImg,
            },
        ]
        if (onBoardingToolTipState === ToolTip_Phase1_Started) {
            slides = allSlides;
        }
        if (onBoardingToolTipState === ToolTip_Phase2_Started) {
            slides = allSlides.splice(1);
        }
        if (onBoardingToolTipState === ToolTip_Phase3_Started) {
            slides = allSlides.splice(3);
        }
        if (onBoardingToolTipState === ToolTip_Phase4_Started) {
            slides = allSlides.splice(4);
        }

        return slides;
    };


    const Carousel = React.useMemo(() => {
        const renderSlides = () =>
            slides.map((slide, index) => (
                <div className='onboarding-carousel-slide' key={slide.id}>
                    <div className='onboarding-carousel-slide__img'>
                        <img src={slide.img} alt={`${slide.heading}`} />
                    </div>
                    <div className='onboarding-carousel__footer'>
                        <Divider mTop="none" mBottom="xlarge" mLeft="none" mRight="none" />
                        <div className='onboarding-carousel-slide__description'>
                            <Typography type="body-02" color="$color-primary-a2" textAlign="center" tag="div">{slide.body}</Typography>
                        </div>
                    </div>
                </div>
            ));
        return (
            <div className='onboarding-carousel'>
                {slides?.length > 1
                    ? <Slider ref={sliderRef}
                        dots={true}
                        autoplay={false}
                        autoplaySpeed={3000}
                        pauseOnHover={true}
                        pauseOnFocus={true}
                        arrows={false}
                        adaptiveHeight={true}
                        beforeChange={(current, next) => setSlideIndex(next)}
                    >
                        {renderSlides()}
                    </Slider>
                    : renderSlides()
                }
            </div>
        );
    }, [slides, isPortraitImage]);

    const ModalHeader = () => {
        return (
            <div className='onboarding-carousel-modal-header'>
                <Typography type="body-02" bold color="$color-primary-a2" tag="div" textAlign="left" responsive>
                    <div>NEW ON MYBSWHEALTH</div>
                    <div className="header-divider-underline" />
                </Typography>
            </div>
        )
    }

    return (
        <Modal isOpen={isOpen} onCloseClick={OnCloseBtn}
            alignText="left"
            className="onboarding-carousel-modal"
            modalHeader={<ModalHeader />}
            modalBody={
                <div>
                    {Carousel}

                    <div className='onboarding-carousel-modal__footer-buttons'>
                        <div>
                            {slideIndex > 0 &&
                                <>{isDesktop
                                    ? <Button
                                        variant="secondary"
                                        icon="chevron-left"
                                        onClick={() => sliderRef?.current?.slickPrev()}
                                    >
                                        Back
                                    </Button>
                                    : <LinkText
                                        as={<span></span>}
                                        onClick={() => sliderRef?.current?.slickPrev()}>
                                        <Icon name="chevron-left" /> Back
                                    </LinkText>
                                }</>
                            }
                        </div>
                        <div>
                            {isDesktop
                                ? <Button
                                    icon="chevron-right"
                                    iconPosition="right"
                                    onClick={() => {
                                        if (slides?.length > 1) {
                                            sliderRef?.current?.slickNext();
                                        }
                                        if ((slideIndex === slides.length - 1)) {
                                            onDismiss(ToolTip_Refresh_AllPhases_Completed);
                                        }
                                    }}
                                >
                                    {slideIndex === slides.length - 1 ? "Done" : "Next"}
                                </Button>
                                : <LinkText
                                    as={<span></span>}
                                    onClick={() => {
                                        if (slides?.length > 1) {
                                            sliderRef?.current?.slickNext();
                                        }
                                        if ((slideIndex === slides.length - 1)) {
                                            onDismiss(ToolTip_Refresh_AllPhases_Completed);
                                        }
                                    }}>
                                    {slideIndex === slides.length - 1 ? "Done" : "Next"} <Icon name="chevron-right" />
                                </LinkText>
                            }
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export default React.memo(OnboardingCarouselModal);